module.exports = __webpack_public_path__ + "img/affirm.b5c2db13.svg";